import {post} from './request'

export const monitoringEdit = param => post('/risk/monitoringEdit', param);
